import { useState, useEffect } from "react";
import "../support-extra/css/CashPopup.css";
import "../css/CashPopupExtra.css";
import ButtonIconH from "./ButtonIconH";
import DataTable from "react-data-table-component";
import { post } from "../js/post";
import { formatValueUnit, userData } from "../js/utils";
import { salesSeeMoreColumns } from "../js/tableColumns";

export default ({ opticId, opticName, ano, onClose, show, agentId }) => {
  const [data, setData] = useState({});

  const getData = async () => {
    const response = await post(
      "/support-extra/dashboard/ObtenerVerMasVentas.php",
      {
        token: userData.token,
        idOptica: opticId,
        idAgente: agentId,
        ano,
      },
    );
    setData(response);
  };

  useEffect(() => {
    if (show) getData();
  }, [opticId, agentId]);

  return (
    show && (
      <div className="popup-container popup-normal popup-cash popup-cash-extra">
        <div
          className="popup-message background-gray"
          style={{ maxWidth: "none", gap: 0 }}
        >
          <div className="popup-header">
            <div className="popup-title">Estadísticas</div>
            <button
              className="popup-action-icon"
              onClick={() => {
                onClose();
              }}
            >
              <img
                src="images/close-white.svg"
                loading="lazy"
                alt="close"
                className="popup-close"
              />
            </button>
          </div>
          <div
            className="container-panel"
            style={{
              margin: 10,
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div className="popup-body" style={{ padding: 0 }}>
              <div className="popup-cash detailed-view-body">
                <div className="dashboard-section-or-title">
                  {(opticId !== "" ? opticId : agentId) + " - " + opticName}
                </div>
                <div className="popup-row popup-row-bold sm-popup">
                  <div>
                    <span className="history-box-tag">Ejercicio</span>
                    <span>{ano}</span>
                  </div>
                  <div>
                    <span className="history-box-tag">Volumen de ventas</span>
                    <span>{formatValueUnit(data.volumenVentas, "€")}</span>
                  </div>
                  <div>
                    <span className="history-box-tag">
                      Volumen de devoluciones
                    </span>
                    <span>
                      {formatValueUnit(data.volumenDevoluciones, "€")}
                    </span>
                  </div>
                  <div>
                    <span className="history-box-tag">Total V-D</span>
                    <span>{formatValueUnit(data.totalVD, "€")}</span>
                  </div>
                  <div>
                    <span className="history-box-tag">Beneficio</span>
                    <span>{formatValueUnit(data.beneficio, "€")}</span>
                  </div>
                </div>
                <div className="popup-row table-scrollable">
                  <DataTable
                    columns={salesSeeMoreColumns}
                    data={data.listado}
                    className="custom-datatable non-interactive"
                    noDataComponent="No hay datos disponibles."
                  />
                </div>
              </div>
            </div>
            <div className="popup-cash-footer" style={{ marginBottom: 0 }}>
              <ButtonIconH text="Imprimir" onClick={() => {}} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
